import React, { Component } from "react";
// import MainProfile from './MainProfile.jsx';
import InitialMainProfile from "./InitialMainProfile.jsx";
import { withStyles } from "@material-ui/core/styles";
import { compose } from "redux";
import { Button, TextField } from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import LogoutAlert from "../../components/Alert/LogoutAlert.jsx";
import UpdateProfile from "./UpdateProfile.jsx";
import * as actions from '../../actions/index.js';
import { FormattedMessage, injectIntl } from "react-intl";
import { ROLE_CUSTOMER, ROLE_PROVIDER, SERVER_URL } from "../../utils/config/constants.js";
import { withRouter } from "react-router-dom";
import { AccountBalanceWallet, SearchIcon } from "@material-ui/icons";
import { connect } from "react-redux";
import { Clear, Add, Remove, ArrowLeft, ArrowRight, ArrowForward, ArrowBack, Category, AccessTime, CancelOutlined } from '@material-ui/icons';
import ContentLoader from "react-content-loader";
import { getCookies } from "../../utils/getToken.js";
import Axios from "axios";
import NavbarNew from "../../components/NavBarNew/NavbarNew.js";
import AreYouSureAlert from "../../components/Alert/AreYouSureAlert.jsx";
import { NotificationManager } from "react-notifications";
import { validateReferral } from "../../utils/helpers/functions/validators.js";

class ReferAndEarnScreenNew extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showAlertAccept: false,
            showAlertReject: false,

            fullNameValue: '',
            mobileValue:'',
            referalValue:'',
            fullNameErr: false,
            mobileErr: false,
            referalErr: false,
        };
    }
    componentDidMount() {
    }

    componentWillUnmount() {
    }

    renderLoading = index => {
        return (
            <div style={{ width: 250, margin: 10, height: 250 }} key={index}>
                <ContentLoader
                    height={200}
                    width={200}
                    speed={2}
                    borderRadius={5}
                    primaryColor="#f3f3f3"
                    secondaryColor="#ecebeb"
                >
                    <rect x="0" y="0" rx="0" ry="0" width="200" height="160" />
                    <rect
                        x="100"
                        y="100"
                        rx="0"
                        ry="0"
                        width="200"
                        height="10"
                    />
                </ContentLoader>
            </div>
        );
    };

    roundUpTransaction = (transaction) => {
        let roundUpValue = transaction.toString()
    
        if(roundUpValue.includes('.')){
            return Number(transaction).toFixed(2)
        } else {
          return Number(transaction)
        }
    }

    generateUUID = (digits) => {
        let str = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVXZ';
        let uuid = [];
        for (let i = 0; i < digits; i++) {
            uuid.push(str[Math.floor(Math.random() * str.length)]);
        }
        this.setState({
            referalValue: uuid.join('')
        })
    }

    onGenerate = () => {
        this.generateUUID(12)
        console.log('uuuidddd',this.state.referalValue)
    }

    onRefer = () => {
        // if(this.state.fullNameValue == ''){
        //     this.setState({
        //         fullNameErr: true
        //     })
        // } else if(this.state.mobileValue == ''){
        //     this.setState({
        //         mobileErr: true
        //     })
        // } else if(this.state.referalValue == ''){
        //     this.setState({
        //         referalErr: true
        //     })
        // }

        if (
            validateReferral(this.state.fullNameValue, this.state.mobileValue, this.state.referalValue, (params) => this.handleError(params)) 
            && this.state.referalValue != ''
        ) {
            this.setState({ 
                // error: '',
                fullNameErr: false,
                mobileErr: false,
                referalErr: false, 
            });
            // alertSuccess(this, 'Referal saved successfully')
            this.CreateReferal();
        }  else {
            // alertError(this,'Please enter required feilds.')
        } 
    }

    handleError = (params) => {
        this.setState(params);
        // alertError(this, 'Enter valid phone number.')
    }

    CreateReferal = async() => {
        var authToken = getCookies();
        console.log('AUTH TOKEN', authToken);
        this.setState({
          showAlert: false
        })
        try {
          const {data} = await Axios({
            method: 'post', 
            url: `${SERVER_URL}/refer/create`,
            data: {
                refer_code:this.state.referalValue,
                refer_name: this.state.fullNameValue,
                refer_phone: this.state.mobileValue,
                refer_email: ''
            },
            headers: {
              'x-auth-Token': authToken,
            },
          });
          if (data.status == 'OK') {
            this.setState({
              loading:false,
              fullNameValue: '',
              mobileValue:'',
              referalValue:'',
              fullNameErr: false,
              mobileErr: false,
              referalErr: false,
            })
            NotificationManager.success(data.message, 'Success');
            this.props.history.push('/user/dashboard')
          }
          else{
            this.setState({
              loading:false
            })
            NotificationManager.error(data.message, 'Error');
            this.props.history.push('/user/dashboard')
          }
        } catch (error) {
          console.log("=======================REFER CREATE ERRORRRRRR",error);
        }
    }

    render() {
        var card={
            border: '1px solid #eee',
            boxShadow: '1px 1px 20px #ddd',
            borderRadius: '10px',
            marginBottom: 20,
            padding: 20,
        }
        var cardHeading={
            backgroundColor: '#0078ff',
            color: 'white',
            fontWeight: '600',
            padding: '5px 20px',
            borderRadius: 50
        }
        var infoHead={
            color: 'green',
            fontSize: 18,
            fontWeight: '700'
        }
        
        return (
            <div className="tz-2-com tz-2-main h4-padding">
                <div style={{ paddingBottom: "25px" }} className="db-list-com">
                    <div className="row">
                        <div className="col-md-12">
                            <NavbarNew
                                title='Refer and Earn' 
                                goback={() => this.props.history.goBack(null)} 
                            />
                            <div id="refer_pad">
                                
                                <p style={{
                                        fontSize: 25,
                                        color: 'black',
                                        marginBottom: 30
                                    }}>We got a good thing going here, share with your friends and earn credits</p>
                                <div>
                                    <p style={{
                                        paddingLeft: 5,
                                        marginTop: 35,
                                        fontSize:   17,
                                        fontWeight: 'bold'
                                    }}>Full Name</p>
                                    <div
                                        style={{
                                            border: "1px solid #C6CBD4",
                                            display: 'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'center',
                                            width: '100%',
                                            padding: 10,
                                            paddingBottom: 6,
                                            marginRight: 10,
                                            borderRadius: 5
                                        }}
                                    >
                                        <TextField
                                            placeholder="Full Name"
                                            autoFocus={this.state.focus}
                                            autoComplete={false}
                                            value={this.state.fullNameValue}
                                            InputProps={{ disableUnderline: true }}
                                            onChange={(event) => 
                                                event.target.value !== '' 
                                                ? this.setState({
                                                    fullNameValue: event.target.value,
                                                    fullNameErr: false
                                                })
                                                : this.setState({
                                                    fullNameValue: '',
                                                    fullNameErr: true,
                                                })
                                            }
                                            style={{}}
                                        />
                                    </div>
                                    {
                                        this.state.fullNameErr
                                        ? <p style={{
                                            paddingLeft: 5,
                                            color: 'red',
                                            marginTop: 5
                                            // marginBottom: 35,
                                        }}>Please Enter full name</p>
                                        : null
                                    }
                                    <p style={{
                                        paddingLeft: 5,
                                        marginTop: 35,
                                        fontSize:   17,
                                        fontWeight: 'bold'
                                    }}>Mobile</p>
                                    <div
                                        style={{
                                            border: "1px solid #C6CBD4",
                                            display: 'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'center',
                                            width: '100%',
                                            padding: 10,
                                            paddingBottom: 6,
                                            marginRight: 10,
                                            borderRadius: 5
                                        }}
                                    >
                                        <TextField
                                            placeholder="Mobile"
                                            type="number"
                                            autoFocus={this.state.focus}
                                            autoComplete={false}
                                            value={this.state.mobileValue}
                                            InputProps={{ disableUnderline: true }}
                                            onChange={(event) => 
                                                event.target.value !== '' 
                                                ? this.setState({
                                                    mobileValue: event.target.value,
                                                    mobileErr: false
                                                })
                                                : this.setState({
                                                    mobileValue: '',
                                                    mobileErr: true,
                                                })
                                            }
                                            style={{}}
                                        />
                                    </div>
                                    {
                                        this.state.mobileErr
                                        ? <p style={{
                                            paddingLeft: 5,
                                            color: 'red',
                                            marginTop: 5
                                            // marginBottom: 35,
                                        }}>Please Enter valid Mobile</p>
                                        : null
                                    }
                                    <p style={{
                                        paddingLeft: 5,
                                        marginTop: 35,
                                        fontSize:   17,
                                        fontWeight: 'bold'
                                    }}>Referal Code</p>
                                    <div style={{
                                        display: 'flex',
                                        // flexDirection: 'column',
                                        alignItems: 'baseline',
                                        width: '100%',
                                    }}>
                                        <div
                                            style={{
                                                border: "1px solid #C6CBD4",
                                                display: 'flex',
                                                flexDirection: 'column',
                                                justifyContent: 'center',
                                                width: '80%',
                                                padding: 10,
                                                paddingBottom: 6,
                                                marginRight: 10,
                                                borderRadius: 5,
                                            }}
                                        >
                                            <TextField
                                                placeholder="Referal Code"
                                                autoFocus={this.state.focus}
                                                autoComplete={false}
                                                // disabled={true}
                                                value={this.state.referalValue}
                                                InputProps={{ disableUnderline: true }}
                                                onChange={(referalValue) => this.setState({ referalValue, referalErr: false })
                                                    // event.target.value !== '' 
                                                    // ? this.setState({
                                                    //     referalValue: event.target.value,
                                                    //     referalErr: false
                                                    // })
                                                    // : this.setState({
                                                    //     referalValue: '',
                                                    //     referalErr: true,
                                                    // })
                                                }
                                                style={{
                                                    //backgroundColor: 'red',
                                                    border: 'none',
                                                    fontWeight: '500',
                                                    color: 'black',
                                                }}
                                            />
                                        </div>
                                        <p
                                            onClick={()=> this.onGenerate()}
                                            style={{
                                                    textDecoration: 'underline',
                                                    padding: 5,
                                                    width: '20%',
                                                    textAlign: 'center',
                                                    color: '#0078ff',
                                                    fontSize: 20,
                                                    cursor: 'pointer'
                                                }}
                                        >Generate</p>
                                    </div>
                                    {
                                        this.state.referalErr
                                        ? <p style={{
                                            paddingLeft: 5,
                                            color: 'red',
                                            marginTop: 5
                                            // marginBottom: 35,
                                        }}>Please generate code</p>
                                        : null
                                    }
                                </div>
                            </div>
                            <div
                            id="refer"
                            style={{
                                    display: 'flex',
                                    justifyContent: 'end',
                                    marginTop: 20
                                }}>
                                {/* <p 
                                    onClick={()=> {
                                        this.setState({showAlert2: true})
                                    }}
                                style={{
                                    backgroundColor: 'red',
                                    padding: 10,
                                    color: '#fff',
                                    borderRadius: 5,
                                    fontSize: 16,
                                    textAlign: 'center',
                                    marginRight: 15,
                                    fontWeight: 'bold',
                                    display: 'flex',
                                    alignItems: 'center'
                                }}>Decline<ArrowForward /></p> */}
                                <p 
                                    onClick={()=> 
                                        this.onRefer()
                                    // {
                                    //     this.setState({showAlert1: true})
                                    // }
                                }
                               
                                style={{
                                    backgroundColor: '#0078ff',
                                    padding: 10,
                                    color: '#fff',
                                    borderRadius: 5,
                                    fontSize: 18,
                                    width: 120,
                                    textAlign: 'center',
                                    fontWeight: 'bold',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    cursor:"pointer"
                                    
                                }}>Refer</p>
                            </div>
                        </div>
                    </div>
                </div>
                <AreYouSureAlert
                    open={this.state.showAlert1}
                    title=""
                    content="By referring someone the person will get discount on their first booking. Do you want to continue?"
                    close={() => this.setState({ showAlert1: false })}
                    handleYes={this.onRefer}
                    handleNo={() => this.setState({ showAlert1: false })}
                />
            </div>
        );
    }
}

const mapStateToProps = ({ settings, categories, providers }) => {
    return {
        settings,
        categoryData: categories.categoryData,
        featuredProviderList: providers.featuredProviderList,
        featuredProviderLoader: providers.featuredProviderLoader
    };
};
const composedProfile = compose(connect(mapStateToProps, actions));
export default composedProfile(withRouter(ReferAndEarnScreenNew));



// WEBPACK FOOTER //
// ./src/views/User/ReferAndEarnScreenNew.jsx